import { render, staticRenderFns } from "./MyCouponsPointsList.vue?vue&type=template&id=58c69730&"
import script from "./MyCouponsPointsList.vue?vue&type=script&lang=js&"
export * from "./MyCouponsPointsList.vue?vue&type=script&lang=js&"
import style0 from "./MyCouponsPointsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports